(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
    const configNode = document.getElementById('ThemeConfig');
    const config = configNode ? JSON.parse(configNode.textContent) : { routes: {}, strings: {} };
    const liveRegion = document.querySelector('[data-live-region]');
    const announce = (message) => {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      window.setTimeout(() => { liveRegion.textContent = message; }, 30);
    };
    const parseHTML = (text) => new DOMParser().parseFromString(text, 'text/html');
    const openDialog = (dialog, trigger) => {
      if (!dialog) return;
      dialog.dataset.triggerId = trigger?.id || '';
      dialog.showModal();
      const focusTarget = dialog.querySelector('[autofocus], input, button, a[href]');
      focusTarget?.focus();
    };
    const closeDialog = (dialog) => {
      if (!dialog) return;
      const trigger = dialog.dataset.triggerId ? document.getElementById(dialog.dataset.triggerId) : null;
      dialog.close();
      trigger?.focus();
    };
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-dialog-open]');
      if (opener) {
        event.preventDefault();
        openDialog(document.getElementById(opener.dataset.dialogOpen), opener);
        return;
      }
      const detailTab = event.target.closest('.product-detail-tabs a[href^="#"]');
      if (detailTab) {
        event.preventDefault();
        const target = document.querySelector(detailTab.getAttribute('href'));
        if (target) {
          const header = document.querySelector('.site-header-wrap--commerce');
          const offset = header ? header.getBoundingClientRect().height + 12 : 0;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          history.replaceState(null, '', detailTab.getAttribute('href'));
        }
        return;
      }
      const closer = event.target.closest('[data-dialog-close]');
      if (closer) {
        event.preventDefault();
        closeDialog(closer.closest('dialog'));
        return;
      }
      if (event.target instanceof HTMLDialogElement) {
        const rect = event.target.getBoundingClientRect();
        const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) closeDialog(event.target);
      }
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) {
        const input = quantityButton.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        const step = Number(input.step || 1);
        const next = Number(input.value) + Number(quantityButton.dataset.quantityChange) * step;
        input.value = Math.max(Number(input.min || 1), next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const mediaButton = event.target.closest('[data-media-target]');
      if (mediaButton) {
        const gallery = mediaButton.closest('[data-media-gallery]');
        const target = gallery?.querySelector(`#${CSS.escape(mediaButton.dataset.mediaTarget)}`);
        if (window.matchMedia('(max-width: 749px)').matches) {
          target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } else {
          gallery?.querySelectorAll('[data-media-item]').forEach((item) => { item.hidden = item !== target; });
        }
        gallery?.querySelectorAll('[data-media-target]').forEach((item) => { item.setAttribute('aria-current', String(item === mediaButton)); });
      }
      const gridButton = event.target.closest('[data-grid-columns]');
      if (gridButton) {
        const root = gridButton.closest('[data-collection-grid]');
        const grid = root?.querySelector('[data-product-list]');
        if (!grid) return;
        grid.dataset.columns = gridButton.dataset.gridColumns;
        root.querySelectorAll('[data-grid-columns]').forEach((button) => button.setAttribute('aria-pressed', String(button === gridButton)));
      }
      const copyToggle = event.target.closest('[data-collection-copy-toggle]');
      if (copyToggle) {
        const copy = copyToggle.parentElement?.querySelector('[data-collection-copy]');
        if (!copy) return;
        const expanded = copyToggle.getAttribute('aria-expanded') === 'true';
        copy.classList.toggle('is-expanded', !expanded);
        copyToggle.setAttribute('aria-expanded', String(!expanded));
        const copyLabel = copyToggle.querySelector('.collection-content__toggle-label');
        if (copyLabel) copyLabel.textContent = expanded ? copyToggle.dataset.moreLabel : copyToggle.dataset.lessLabel;
      }
      const variantBox = event.target.closest('[data-variant-option]');
      if (variantBox) {
        variantBox.closest('[data-option-position]')?.querySelectorAll('[data-variant-option]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === variantBox));
        });
        updateVariant(variantBox.closest('[data-product-section]'));
      }
    });
    document.addEventListener('cancel', (event) => {
      if (event.target instanceof HTMLDialogElement) event.target.dataset.triggerId = '';
    });
    const zoomStates = new Map();
    const pokeZoomArrows = (state) => {
      state.dialog.classList.remove('is-arrows-idle');
      window.clearTimeout(state.arrowsTimer);
      state.arrowsTimer = window.setTimeout(() => state.dialog.classList.add('is-arrows-idle'), 2500);
    };
    const renderZoom = (state) => {
      if (!state.image || !state.images.length) return;
      const item = state.images[state.index % state.images.length];
      state.image.src = item.src;
      state.image.alt = item.alt || '';
      if (state.count) state.count.textContent = `${state.index + 1} / ${state.images.length}`;
      if (state.thumbs) {
        state.thumbs.querySelectorAll('[data-zoom-thumb]').forEach((thumb, index) => {
          const active = index === state.index;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
          if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        });
      }
      pokeZoomArrows(state);
    };
    const getZoomState = (target) => {
      const section = target?.closest('[data-product-section]');
      const dialog = section ? section.querySelector('[data-zoom-dialog]') : document.querySelector('[data-zoom-dialog]');
      return dialog ? zoomStates.get(dialog) : null;
    };
    const initProductZoom = (root) => {
      const dialog = root.querySelector('[data-zoom-dialog]');
      if (!dialog || zoomStates.has(dialog)) return;
      const state = {
        dialog,
        index: 0,
        images: JSON.parse(dialog.dataset.zoomImages || '[]'),
        image: dialog.querySelector('[data-zoom-image]'),
        count: dialog.querySelector('[data-zoom-count]'),
        thumbs: dialog.querySelector('[data-zoom-thumbs]'),
        arrowsTimer: null,
        pointerStart: null
      };
      dialog.addEventListener('pointerdown', (event) => {
        state.pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        pokeZoomArrows(state);
      });
      dialog.addEventListener('pointermove', () => pokeZoomArrows(state));
      dialog.addEventListener('pointerup', (event) => {
        if (!state.pointerStart || event.pointerId !== state.pointerStart.id) return;
        const deltaX = event.clientX - state.pointerStart.x;
        const deltaY = event.clientY - state.pointerStart.y;
        state.pointerStart = null;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) state.index = (state.index + 1) % state.images.length;
        else state.index = (state.index - 1 + state.images.length) % state.images.length;
        renderZoom(state);
      });
      dialog.addEventListener('pointercancel', () => { state.pointerStart = null; });
      zoomStates.set(dialog, state);
    };
    document.addEventListener('click', (event) => {
      const zoomOpener = event.target.closest('[data-zoom-open]');
      if (zoomOpener) {
        const state = getZoomState(zoomOpener);
        if (!state) return;
        event.preventDefault();
        const gallery = zoomOpener.closest('[data-media-gallery]');
        const stage = gallery?.querySelector('.product-media__stage');
        let activeItem = null;
        if (stage) {
          const items = Array.from(stage.querySelectorAll('[data-media-item]'));
          if (window.matchMedia('(max-width: 749px)').matches) {
            const stageRect = stage.getBoundingClientRect();
            const midX = stageRect.left + stageRect.width / 2;
            activeItem = items.find((item) => {
              const rect = item.getBoundingClientRect();
              return rect.left < midX && rect.right > midX;
            });
          }
          if (!activeItem) activeItem = items.find((item) => !item.hidden) || items[0];
        }
        const requestedIndex = Number(activeItem?.dataset.zoomIndex);
        if (Number.isFinite(requestedIndex) && requestedIndex >= 0) state.index = requestedIndex;
        renderZoom(state);
        openDialog(state.dialog, zoomOpener);
        return;
      }
      const zoomMediaImage = event.target.closest('[data-media-item] img');
      if (zoomMediaImage) {
        const state = getZoomState(zoomMediaImage);
        if (!state) return;
        const zoomItem = zoomMediaImage.closest('[data-media-item]');
        const mediaIndex = Number(zoomItem?.dataset.zoomIndex);
        if (Number.isFinite(mediaIndex) && mediaIndex >= 0) {
          event.preventDefault();
          state.index = mediaIndex;
          renderZoom(state);
          openDialog(state.dialog, zoomItem);
        }
        return;
      }
      const zoomThumb = event.target.closest('[data-zoom-thumb]');
      if (zoomThumb) {
        const state = getZoomState(zoomThumb);
        if (!state) return;
        state.index = Number(zoomThumb.dataset.zoomThumb);
        renderZoom(state);
        return;
      }
      if (event.target.closest('[data-zoom-prev]')) {
        const state = getZoomState(event.target);
        if (!state) return;
        state.index = (state.index - 1 + state.images.length) % state.images.length;
        renderZoom(state);
        return;
      }
      if (event.target.closest('[data-zoom-next]')) {
        const state = getZoomState(event.target);
        if (!state) return;
        state.index = (state.index + 1) % state.images.length;
        renderZoom(state);
      }
    });
    document.addEventListener('keydown', (event) => {
      const dialog = document.querySelector('[data-zoom-dialog]');
      const state = dialog ? zoomStates.get(dialog) : null;
      if (!state || !state.dialog.open) return;
      if (event.key === 'ArrowLeft') {
        state.index = (state.index - 1 + state.images.length) % state.images.length;
        renderZoom(state);
      } else if (event.key === 'ArrowRight') {
        state.index = (state.index + 1) % state.images.length;
        renderZoom(state);
      }
    });
    initProductZoom(document);
    const campaignStage = document.querySelector('.campaign-stage');
    if (campaignStage) {
      campaignStage.classList.add('is-arrows-loading');
      const positionCampaignArrows = () => {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const media = campaignStage.querySelector('.campaign-slide:not([hidden]) .campaign-slide__media');
        if (!mobile || !media || !media.offsetHeight) {
          campaignStage.style.removeProperty('--campaign-arrow-top');
          return;
        }
        const mediaTop = media.getBoundingClientRect().top - campaignStage.getBoundingClientRect().top;
        campaignStage.style.setProperty('--campaign-arrow-top', `${mediaTop + media.offsetHeight / 2}px`);
      };
      const revealCampaignArrows = () => campaignStage.classList.remove('is-arrows-loading');
      positionCampaignArrows();
      window.addEventListener('resize', positionCampaignArrows);
      if (window.ResizeObserver) new ResizeObserver(positionCampaignArrows).observe(campaignStage);
      window.addEventListener('load', revealCampaignArrows, { once: true });
      window.setTimeout(revealCampaignArrows, 2500);
    }
    const commerceHeader = document.querySelector('.site-header-wrap--commerce');
    if (commerceHeader) {
      let headerLastY = window.scrollY;
      let headerTick = false;
      const syncProductStickyTop = () => {
        document.documentElement.style.setProperty('--product-sticky-top', commerceHeader.classList.contains('is-hidden') ? '1rem' : '10.5rem');
      };
      const onHeaderScroll = () => {
        if (headerTick) return;
        headerTick = true;
        window.requestAnimationFrame(() => {
          const y = window.scrollY;
          const delta = y - headerLastY;
          if (y > 140 && delta > 6) commerceHeader.classList.add('is-hidden');
          else if (delta < -6 || y <= 140) commerceHeader.classList.remove('is-hidden');
          headerLastY = y;
          syncProductStickyTop();
          headerTick = false;
        });
      };
      window.addEventListener('scroll', onHeaderScroll, { passive: true });
      syncProductStickyTop();
    }
    const refreshCart = async (open = false) => {
      const response = await fetch(`${config.routes.cart}?section_id=cart-drawer`, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(config.strings.error);
      const doc = parseHTML(await response.text());
      const nextSection = doc.querySelector('#shopify-section-cart-drawer');
      const currentSection = document.querySelector('#shopify-section-cart-drawer');
      if (nextSection && currentSection) currentSection.replaceWith(nextSection);
      const count = nextSection?.querySelector('[data-cart-count-value]')?.textContent || '0';
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === '0';
      });
      if (open && config.cartType === 'drawer') openDialog(document.getElementById('CartDrawer'));
    };
    document.addEventListener('submit', async (event) => {
      const productForm = event.target.closest('[data-product-form]');
      if (!productForm || !window.fetch) return;
      event.preventDefault();
      const submitButtons = Array.from(productForm.closest('[data-product-section]')?.querySelectorAll('[data-add-to-cart]') || []);
      const disabledStates = submitButtons.map((button) => button.disabled);
      submitButtons.forEach((button) => {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      });
      try {
        const response = await fetch(`${config.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || config.strings.error);
        await refreshCart(true);
        announce(config.strings.added);
      } catch (error) {
        const errorNode = productForm.querySelector('[data-product-error]');
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = error.message;
        }
        announce(error.message);
      } finally {
        submitButtons.forEach((button, index) => {
          button.removeAttribute('aria-busy');
          button.disabled = disabledStates[index];
        });
      }
    });
    document.addEventListener('change', async (event) => {
      const cartInput = event.target.closest('[data-cart-quantity]');
      if (cartInput) {
        const cartPageForm = cartInput.closest('#CartPageForm');
        if (cartPageForm) {
          cartPageForm.requestSubmit();
          return;
        }
        try {
          await fetch(`${config.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(cartInput.dataset.line), quantity: Number(cartInput.value) }) });
          await refreshCart();
        } catch (error) { announce(config.strings.error); }
      }
      const sort = event.target.closest('[data-sort-by]');
      if (sort) sort.form?.requestSubmit();
      const facetInput = event.target.closest('[data-facets-form][data-auto-submit] input:not([type="hidden"]):not([data-facet-search])');
      if (facetInput) facetInput.form?.requestSubmit();
    });
    document.addEventListener('input', (event) => {
      const search = event.target.closest('[data-facet-search]');
      if (!search) return;
      const query = search.value.trim().toLocaleLowerCase();
      const values = search.closest('.facet')?.querySelectorAll('[data-facet-value]') || [];
      values.forEach((value) => {
        value.hidden = query !== '' && !value.textContent.toLocaleLowerCase().includes(query);
      });
    });
    document.addEventListener('click', async (event) => {
      const trigger = event.target.closest('[data-load-more]');
      if (!trigger || !window.fetch) return;
      if (new URLSearchParams(window.location.search).has('filter.p.vendor')) return;
      event.preventDefault();
      const section = trigger.closest('.shopify-section');
      const currentList = section?.querySelector('[data-product-list]');
      const currentPagination = section?.querySelector('[data-collection-pagination]');
      if (!section || !currentList || !currentPagination) {
        window.location.href = trigger.href;
        return;
      }
      const originalLabel = trigger.textContent;
      trigger.textContent = trigger.dataset.loadingLabel;
      trigger.setAttribute('aria-busy', 'true');
      try {
        const requestUrl = new URL(trigger.href);
        requestUrl.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
        const response = await fetch(requestUrl);
        if (!response.ok) throw new Error(config.strings.error);
        const doc = parseHTML(await response.text());
        const nextSection = doc.getElementById(section.id);
        const nextList = nextSection?.querySelector('[data-product-list]');
        const nextPagination = nextSection?.querySelector('[data-collection-pagination]');
        if (!nextList || !nextPagination) throw new Error(config.strings.error);
        const products = Array.from(nextList.children);
        products.forEach((product) => currentList.append(product));
        currentPagination.innerHTML = nextPagination.innerHTML;
        applyVendorFilter();
        announce(trigger.dataset.loadedLabel);
      } catch (error) {
        trigger.textContent = originalLabel;
        trigger.removeAttribute('aria-busy');
        announce(error.message);
      }
    });
    const infinitePagination = document.querySelector('[data-collection-pagination]');
    if (infinitePagination && 'IntersectionObserver' in window) {
      const infiniteScrollObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        if (new URLSearchParams(window.location.search).has('filter.p.vendor')) return;
        const trigger = infinitePagination.querySelector('[data-load-more]');
        if (!trigger || trigger.getAttribute('aria-busy') === 'true') return;
        trigger.click();
      }, { rootMargin: '600px 0px' });
      infiniteScrollObserver.observe(infinitePagination);
    }
    document.addEventListener('click', async (event) => {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      const cartPageForm = remove.closest('#CartPageForm');
      if (cartPageForm) {
        const quantity = cartPageForm.querySelector(`[data-cart-quantity][data-line="${remove.dataset.line}"]`);
        if (quantity) quantity.value = 0;
        cartPageForm.requestSubmit();
        return;
      }
      try {
        await fetch(`${config.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(remove.dataset.line), quantity: 0 }) });
        await refreshCart();
      } catch (error) { announce(config.strings.error); }
    });
    const updateVariant = async (section) => {
      if (!section || section.classList.contains('loading')) return;
      const dataNode = section.querySelector('[data-product-variants]');
      if (!dataNode) return;
      const variants = JSON.parse(dataNode.textContent);
      const options = Array.from(section.querySelectorAll('[data-option-position]')).map((group) => group.querySelector('[data-variant-option][aria-pressed="true"]')?.dataset.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
      const submitButtons = section.querySelectorAll('[data-add-to-cart]');
      const idInput = section.querySelector('[name="id"]');
      if (!variant) {
        submitButtons.forEach((button) => {
          button.disabled = true;
          button.textContent = config.strings.unavailable;
        });
        return;
      }
      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      section.classList.add('loading');
      try {
        const response = await fetch(`${url.pathname}${url.search}&section_id=${section.dataset.sectionId}`);
        const doc = parseHTML(await response.text());
        const next = doc.querySelector(`[data-product-section][data-section-id="${section.dataset.sectionId}"]`);
        if (next) {
          section.replaceWith(next);
          initProductZoom(next);
          initProductMediaHover();
        }
      } finally { section.classList.remove('loading'); }
    };
    const initPredictiveSearch = () => {
      document.querySelectorAll('[data-predictive-search]').forEach((root) => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const input = root.querySelector('input[type="search"]');
        const results = root.querySelector('[data-predictive-results]');
        let controller;
        let timer;
        input?.addEventListener('input', () => {
          window.clearTimeout(timer);
          const query = input.value.trim();
          if (query.length < 2) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
          timer = window.setTimeout(async () => {
            controller?.abort();
            controller = new AbortController();
            input.setAttribute('aria-busy', 'true');
            const params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page,article', 'resources[limit]': '8', section_id: 'predictive-search' });
            try {
              const response = await fetch(`${config.routes.predictiveSearch}?${params}`, { signal: controller.signal });
              const doc = parseHTML(await response.text());
              const next = doc.querySelector('[data-predictive-results]');
              if (next) results.innerHTML = next.innerHTML;
              input.setAttribute('aria-expanded', String(Boolean(results.innerHTML.trim())));
            } catch (error) { if (error.name !== 'AbortError') announce(config.strings.error); }
            finally { input.removeAttribute('aria-busy'); }
          }, 180);
        });
      });
    };
    const initAjaxFacets = () => {
      document.querySelectorAll('[data-facets-form]').forEach((form) => {
        if (form.dataset.initialized) return;
        form.dataset.initialized = 'true';
        form.addEventListener('submit', async (event) => {
          if (!window.fetch) return;
          event.preventDefault();
          const params = new URLSearchParams();
          new FormData(form).forEach((value, key) => {
            if (String(value).trim() !== '') params.append(key, String(value));
          });
          const currentParams = new URLSearchParams(window.location.search);
          ['q', 'preview_theme_id', 'preview_theme_key'].forEach((key) => {
            const value = currentParams.get(key);
            if (value && !params.has(key)) params.append(key, value);
          });
          const url = new URL(window.location.href);
          url.search = params.toString();
          const section = form.closest('.shopify-section') || document.getElementById('shopify-section-main-search');
          section?.classList.add('loading');
          try {
            const sectionId = section?.id.replace('shopify-section-', '');
            const requestUrl = new URL(url);
            requestUrl.searchParams.set('section_id', sectionId);
            const response = await fetch(requestUrl);
            const doc = parseHTML(await response.text());
            const next = doc.getElementById(section?.id);
            if (next && section) section.replaceWith(next);
            window.history.pushState({}, '', url);
            initAjaxFacets();
            vendorAllLoaded = false;
            applyVendorFilter();
          } finally { section?.classList.remove('loading'); }
        });
      });
    };
    let vendorLoadInProgress = false;
    let vendorAllLoaded = false;
    const applyVendorFilter = (silent = false) => {
      if (!document.querySelector('[data-custom-vendor-facet]')) return;
      const params = new URLSearchParams(window.location.search);
      const activeVendors = params.getAll('filter.p.vendor');
      const list = document.querySelector('[data-product-list]');
      const countEl = document.querySelector('.collection-toolbar__count');
      const grid = document.querySelector('.product-grid');
      document.querySelectorAll('[data-facets-form] input[name="filter.p.vendor"]').forEach((input) => {
        input.checked = activeVendors.includes(input.value);
      });
      if (activeVendors.length === 0) vendorAllLoaded = false;
      if (!list) return;
      let visible = 0;
      list.querySelectorAll('.product-card').forEach((card) => {
        const vendorEl = card.querySelector('.product-card__vendor');
        const vendor = vendorEl ? vendorEl.textContent.trim() : '';
        const match = activeVendors.length === 0 || activeVendors.includes(vendor);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (countEl && !silent) {
        if (activeVendors.length === 0) {
          if (countEl.dataset.originalCount) countEl.textContent = countEl.dataset.originalCount;
        } else {
          if (!countEl.dataset.originalCount) countEl.dataset.originalCount = countEl.textContent;
          countEl.textContent = `${visible} ürün`;
        }
      }
      let empty = grid ? grid.querySelector('[data-vendor-empty]') : null;
      if (activeVendors.length > 0 && visible === 0) {
        if (!empty) {
          empty = document.createElement('div');
          empty.dataset.vendorEmpty = 'true';
          empty.className = 'empty-state';
          empty.innerHTML = '<h2>Bu markada ürün bulunamadı</h2><a class="button button--secondary" href="' + (document.querySelector('[data-facets-form]')?.getAttribute('action') || window.location.pathname) + '">Tümünü göster</a>';
          grid?.append(empty);
        }
        empty.hidden = false;
      } else if (empty) {
        empty.hidden = true;
      }
      if (activeVendors.length > 0 && !vendorLoadInProgress && !vendorAllLoaded) {
        const pagination = document.querySelector('[data-collection-pagination]');
        const loadMoreHref = pagination?.querySelector('[data-load-more]')?.href;
        const pageLinks = pagination
          ? Array.from(pagination.querySelectorAll('.pagination a[href]'))
              .map((link) => link.href)
              .filter((href) => {
                const page = new URL(href).searchParams.get('page');
                return page && page !== '1';
              })
          : [];
        if (loadMoreHref) pageLinks.unshift(loadMoreHref);
        const uniqueLinks = [...new Set(pageLinks)];
        if (uniqueLinks.length === 0) return;
        const section = document.querySelector('[data-collection-grid]')?.closest('.shopify-section');
        const list = document.querySelector('[data-product-list]');
        if (!section || !list) return;
        vendorLoadInProgress = true;
        const sectionId = section.id.replace('shopify-section-', '');
        Promise.all(
          uniqueLinks.map(async (href) => {
            const url = new URL(href);
            url.searchParams.set('section_id', sectionId);
            const response = await fetch(url);
            if (!response.ok) throw new Error(config.strings.error);
            const doc = parseHTML(await response.text());
            const nextList = doc.getElementById(section.id)?.querySelector('[data-product-list]');
            return nextList ? Array.from(nextList.children) : [];
          })
        )
          .then((batches) => {
            batches.forEach((cards) => cards.forEach((card) => list.append(card)));
            vendorLoadInProgress = false;
            vendorAllLoaded = true;
            applyVendorFilter(false);
          })
          .catch(() => {
            vendorLoadInProgress = false;
            vendorAllLoaded = true;
            applyVendorFilter(false);
          });
      }
    };
    const initRecommendations = () => {
      document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
        if (section.dataset.initialized || !section.dataset.url) return;
        section.dataset.initialized = 'true';
        try {
          const response = await fetch(section.dataset.url);
          const doc = parseHTML(await response.text());
          const next = doc.querySelector('[data-product-recommendations]');
          if (next?.innerHTML.trim()) section.replaceWith(next);
        } catch (error) { section.hidden = true; }
      });
    };
    const initCampaignCarousels = () => {
      document.querySelectorAll('[data-campaign-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized) return;
        carousel.dataset.initialized = 'true';
        const slides = Array.from(carousel.querySelectorAll('[data-campaign-slide]'));
        const tabs = Array.from(carousel.querySelectorAll('[data-campaign-tab]'));
        const thumbnails = Array.from(carousel.querySelectorAll('[data-campaign-thumbnail]'));
        if (slides.length < 2) return;
        let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let timer;
        const setActive = (nextIndex, moveFocus = false) => {
          activeIndex = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const active = index === activeIndex;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
          });
          tabs.forEach((tab, index) => {
            const active = index === activeIndex;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          thumbnails.forEach((thumbnail, index) => thumbnail.classList.toggle('is-active', index === activeIndex));
          if (moveFocus) tabs[activeIndex]?.focus();
        };
        const stopAutoplay = () => window.clearInterval(timer);
        const startAutoplay = () => {
          stopAutoplay();
          if (carousel.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          timer = window.setInterval(() => setActive(activeIndex + 1), Number(carousel.dataset.interval || 6000));
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => { setActive(index); startAutoplay(); });
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            setActive(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
            startAutoplay();
          });
        });
        thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => { setActive(index); startAutoplay(); }));
        carousel.querySelector('[data-campaign-previous]')?.addEventListener('click', () => { setActive(activeIndex - 1); startAutoplay(); });
        carousel.querySelector('[data-campaign-next]')?.addEventListener('click', () => { setActive(activeIndex + 1); startAutoplay(); });
        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) startAutoplay(); });
        setActive(activeIndex);
        startAutoplay();
      });
    };
    const initQuickNavScroll = () => {
      document.querySelectorAll('[data-quick-nav]').forEach((nav) => {
        const inner = nav.querySelector('[data-quick-nav-inner]');
        const prev = nav.querySelector('[data-quick-nav-prev]');
        const next = nav.querySelector('[data-quick-nav-next]');
        if (!inner || !prev || !next) return;
        const update = () => {
          const overflow = inner.scrollWidth > inner.clientWidth + 4;
          const atStart = inner.scrollLeft <= 4;
          const atEnd = inner.scrollLeft >= inner.scrollWidth - inner.clientWidth - 4;
          prev.hidden = !overflow || atStart;
          next.hidden = !overflow || atEnd;
        };
        const step = () => Math.max(Math.round(inner.clientWidth * 0.8), 240);
        prev.addEventListener('click', () => inner.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => inner.scrollBy({ left: step(), behavior: 'smooth' }));
        inner.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    };
    const initQuickNavDrag = () => {
      document.querySelectorAll('[data-quick-nav-inner]').forEach((inner) => {
        let isDown = false;
        let startX = 0;
        let startLeft = 0;
        let dragDistance = 0;
        let suppressClick = false;
        const onPointerMove = (event) => {
          if (!isDown) return;
          const dx = event.clientX - startX;
          dragDistance = Math.max(dragDistance, Math.abs(dx));
          if (dragDistance <= 8) return;
          inner.scrollLeft = startLeft - dx;
          event.preventDefault();
        };
        const onPointerUp = (event) => {
          if (!isDown) return;
          isDown = false;
          suppressClick = dragDistance > 8;
          inner.classList.remove('is-dragging');
          document.removeEventListener('pointermove', onPointerMove);
          document.removeEventListener('pointerup', onPointerUp);
          document.removeEventListener('pointercancel', onPointerUp);
        };
        const onPointerDown = (event) => {
          if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          document.removeEventListener('pointermove', onPointerMove);
          document.removeEventListener('pointerup', onPointerUp);
          document.removeEventListener('pointercancel', onPointerUp);
          isDown = true;
          startX = event.clientX;
          startLeft = inner.scrollLeft;
          dragDistance = 0;
          suppressClick = false;
          inner.classList.add('is-dragging');
          document.addEventListener('pointermove', onPointerMove);
          document.addEventListener('pointerup', onPointerUp);
          document.addEventListener('pointercancel', onPointerUp);
        };
        inner.addEventListener('pointerdown', onPointerDown);
        inner.addEventListener('dragstart', (event) => event.preventDefault());
        inner.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }, true);
      });
    };
    const initProductMediaHover = () => {
      document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
        const thumbs = gallery.querySelector('.product-media__thumbs');
        if (!thumbs) return;
        const showMedia = (button) => {
          const target = gallery.querySelector(`#${CSS.escape(button.dataset.mediaTarget)}`);
          if (!target) return;
          gallery.querySelectorAll('[data-media-item]').forEach((item) => { item.hidden = item !== target; });
        };
        thumbs.querySelectorAll('[data-media-target]').forEach((button) => {
          button.addEventListener('mouseenter', () => {
            if (window.matchMedia('(max-width: 749px)').matches) return;
            showMedia(button);
          });
        });
        thumbs.addEventListener('mouseleave', () => {
          if (window.matchMedia('(max-width: 749px)').matches) return;
          const active = gallery.querySelector('[data-media-target][aria-current="true"]');
          if (active) showMedia(active);
        });
      });
    };
    window.addEventListener('popstate', () => window.location.reload());
    initPredictiveSearch();
    initAjaxFacets();
    applyVendorFilter();
    initRecommendations();
    initCampaignCarousels();
    initQuickNavScroll();
    initQuickNavDrag();
    initProductMediaHover();
    document.querySelectorAll('[data-collection-copy-toggle]').forEach((button) => {
      const copy = button.parentElement?.querySelector('[data-collection-copy]');
      if (copy && copy.scrollHeight > copy.clientHeight + 8) {
        button.hidden = false;
        copy.classList.add('is-clipped');
      }
    });
    document.addEventListener('shopify:section:load', () => {
      initPredictiveSearch();
      initAjaxFacets();
      applyVendorFilter();
      initRecommendations();
      initCampaignCarousels();
      initQuickNavScroll();
      initQuickNavDrag();
      initProductMediaHover();
      document.querySelectorAll('[data-collection-copy-toggle]').forEach((button) => {
        const copy = button.parentElement?.querySelector('[data-collection-copy]');
        if (copy && copy.scrollHeight > copy.clientHeight + 8) button.hidden = false;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
